import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map, take } from "rxjs/operators";
import { CapabilityString } from "../directives/capabilities/capabilities-params.model";
import { CapabilitiesHttpService } from "../services/capabilities/capabilities.http.service.service";

@Injectable({
  providedIn: "root"
})
export class SystemCapabilityGuard {
  constructor(
    private readonly capabilitiesHttpService: CapabilitiesHttpService,
    private readonly router: Router
  ) { }

  canActivate = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
    const required = route.data["systemCapability"] as CapabilityString;
    return this.capabilitiesHttpService.getSystemCapabilities().pipe(
      take(1),
      map((response) =>
        required && response?.systemCapabilities?.includes(required)
          ? true
          : this.router.parseUrl("/not-found")
      ),
      catchError(() => of(this.router.parseUrl("/not-found")))
    );
  }
}
